import { render, staticRenderFns } from "./ComponentResolverMobile.vue?vue&type=template&id=32fb89f0"
import script from "./ComponentResolverMobile.js?vue&type=script&lang=js&external"
export * from "./ComponentResolverMobile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports